import {EventEditor} from "./EventEditor.js";

export class StartNodeEditor extends EventEditor {
	constructor(parent, node, coords) {
		super(parent, node, coords);
	}
}